import {helpers} from '../common/helpers';

function getScrollPerc() {
	let perc;
	let scroll = $(window).scrollTop();
	let heroHeight = $('.hero').outerHeight();
	let windowHeight = $(window).height();
	let totalHeight = $('html').outerHeight();

	if (scroll >= heroHeight) {
		perc = (scroll + windowHeight) / totalHeight;
	} else {
		perc = 0;
	}

	return perc;
}

function stickyMenu(once) {
	if (once) {
		window.scrollDirection = 'down';
	}

	if ($('.hero').length) {
		if ($(window).scrollTop() > $('.hero').outerHeight() && window.scrollDirection === 'down' && !$('.header').hasClass('is-fixed')) {
			$('.header').addClass('is-fixed').removeClass('is-hiding');
		}

		if ($(window).scrollTop() < $('.hero').outerHeight() && window.scrollDirection === 'up' && $('.header').hasClass('is-fixed')) {
			$('.header').addClass('is-hiding');

			setTimeout(() => {
				$('.header').removeClass('is-fixed is-hiding');
			}, 200);
		}
	}

	if (!$('.hero').length) {
		if ($(window).scrollTop() > $('.header').outerHeight()) {
			$('.header').addClass('is-fixed');
		} else {
			$('.mobile-menu').removeClass('fixed');
		}
	}
}

stickyMenu(true);
$(window).on('scroll', () => {
	stickyMenu();

	TweenMax.to($('.header__progress')[0], 0.2, {
		scaleX: getScrollPerc(),
		overwrite: 'all',
	});
});

$('.hero__scrolldown').on('click', (e) => {
	let scrollLength;

	$(e.currentTarget).blur();

	if ($('.hero').length) {
		scrollLength = $('.hero').next().offset().top;

		// TweenLite.to(window, 1, {
		// 	scrollTo: scrollLength - 150,
		// });

		$('body, html').animate({ scrollTop: scrollLength }, 1000);
	}
});

$('.header__scrollbtn').on('click', (e) => {
	$(e.currentTarget).blur();

	// TweenLite.to(window, 1, {
	// 	scrollTo: 0,
	// });

	$('body, html').animate({ scrollTop: 0 }, 1000);
});

// fill heading number on scroll
function checkNumberInView() {
	$('.heading__number').each((i, elem) => {
		if (elem.getBoundingClientRect().top - $(window).height() / 3 <= 0) {
			$(elem).addClass('is-filled');
		} else {
			$(elem).removeClass('is-filled');
		}
	});
}

checkNumberInView();
$(window).on('scroll', () => {
	checkNumberInView();
});

// bg color toggle on scroll
function toggleColor() {
	let elemCounter = 0;

	$('.js-bg-toggle').each((i, elem) => {
		if (helpers.isElementPartiallyInViewport(elem, 20)) {
			elemCounter += 1;
		}
	});

	if (elemCounter) {
		$('body').addClass('is-bg-gray');
	} else {
		$('body').removeClass('is-bg-gray');
	}
}

toggleColor();
$(window).on('scroll', () => {
	toggleColor();
});
